import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'authentication',
    loadChildren: () => import('./authentication/authentication.routes').then(m => m.routes),
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.routes').then(m => m.routes),
  },

  // {
  //   path: 'notifications',
  //   loadChildren: () => import('./notification/notification.routes').then(m => m.routes),
  // },

  //#region Calendar module
  {
    path: 'calendar',
    loadChildren: () => import('./calendar/calendar.routes').then(m => m.routes),
  },
  //#endregion Calendar module

  // //#region Tasks module
  // {
  //   path: 'tasks',
  //   loadChildren: () => import('./task/task.routes').then(m => m.routes),
  // },
  // //#endregion Tasks module

  // //#region Client management module
  {
    path: 'clients',
    loadChildren: () => import('./client/client.routes').then(m => m.routes),
  },
  {
    path: 'client-leads',
    loadChildren: () => import('./client-lead/client-lead.routes').then(m => m.routes),
  },
  // {
  //   path: 'referral-groups',
  //   loadChildren: () => import('./referral-group/referral-group.routes').then(m => m.routes),
  // },
  // //#endregion Client management module

  //#region Trip management module
  {
    path: 'trips',
    loadChildren: () => import('./trip/trip.routes').then(m => m.routes),
  },
  {
    path: 'trip-activities',
    loadChildren: () => import('./trip-activity/trip-activity.routes').then(m => m.routes),
  },
  {
    path: 'bookings',
    loadChildren: () => import('./booking/booking.routes').then(m => m.routes),
  },
  // {
  //   path: 'bookings-unclaimed',
  //   loadChildren: () => import('./booking-unclaimed/booking-unclaimed.routes').then(m => m.routes),
  // },
  // //#endregion Trip management module

  // //#region Commission module
  // {
  //   path: 'commission-received',
  //   loadChildren: () => import('./commission-received/commission-received.routes').then(m => m.routes),
  // },
  // {
  //   path: 'commission-paid',
  //   loadChildren: () => import('./commission-paid/commission-paid.routes').then(m => m.routes),
  // },
  // {
  //   path: 'commission-due',
  //   loadChildren: () => import('./commission-due/commission-due.routes').then(m => m.routes),
  // },
  // {
  //   path: 'commission-adjustment',
  //   loadChildren: () => import('./commission-adjustment/commission-adjustment.routes').then(m => m.routes),
  // },
  // //#endregion Commission module

  //#region Supplier module
  {
    path: 'tour-operators',
    loadChildren: () => import('./tour-operator/tour-operator.routes').then(m => m.routes),
  },
  // {
  //   path: 'airlines',
  //   loadChildren: () => import('./airline/airline.routes').then(m => m.routes),
  // },
  {
    path: 'cruise-lines',
    loadChildren: () => import('./cruise-line/cruise-line.routes').then(m => m.routes),
  },
  {
    path: 'properties',
    loadChildren: () => import('./property/property.routes').then(m => m.routes),
  },
  // {
  //   path: 'tour-lines',
  //   loadChildren: () => import('./tour-line/tour-line.routes').then(m => m.routes),
  // },
  // //#endregion Supplier module

  // //#region Reporting module
  // {
  //   path: 'reporting',
  //   loadChildren: () => import('./reporting/reporting.routes').then(m => m.routes),
  // },
  // //#endregion Reporting module

  // //#region My account module
  // {
  //   path: 'users',
  //   loadChildren: () => import('./user/user.routes').then(m => m.routes),
  // },
  // {
  //   path: 'user-leads',
  //   loadChildren: () => import('./user-lead/user-lead.routes').then(m => m.routes),
  // },
  // {
  //   path: 'companies',
  //   loadChildren: () => import('./company/company.routes').then(m => m.routes),
  // },
  // //#endregion My account module

  // //#region Agency portal module
  // {
  //   path: 'agency-portal',
  //   loadChildren: () => import('./agency-portal/agency-portal.routes').then(m => m.routes),
  // },
  // //#endregion Agency portal module

  // //#region My library module
  {
    path: 'email-templates',
    loadChildren: () => import('./email-template/email-template.routes').then(m => m.routes),
  },
  {
    path: 'canvas-templates',
    loadChildren: () => import('./canvas-template/canvas-template.routes').then(m => m.routes),
  },
  {
    path: 'images',
    loadChildren: () => import('./image/image.routes').then(m => m.routes),
  },
  // //#endregion My library module

  // //#region Workflow module
  // {
  //   path: 'tabs',
  //   loadChildren: () => import('./workflow-tab/workflow-tab.routes').then(m => m.routes),
  // },
  // {
  //   path: 'workflows',
  //   loadChildren: () => import('./workflow/workflow.routes').then(m => m.routes),
  // },
  // //#endregion Workflow module

  //#region Marketing module
  {
    path: 'email-marketing-campaigns',
    loadChildren: () => import('./email-marketing/email-marketing.routes').then(m => m.routes),
  },
  //#endregion Marketing module

  // //#region Helpdesk module
  // {
  //   path: 'helpdesk',
  //   loadChildren: () => import('./help-desk/help-desk.routes').then(m => m.routes),
  // },
  // //#endregion Helpdesk module
  {
    path: 'test',
    loadChildren: () => import('./test/test.routes').then(m => m.routes),
  },
];
